import type { DeviceActionHydraCollectionItem } from "@verbleif/lib/src/composables/Api/Type/Device/device_action.interface";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

/**
 * Mirrors the API device action security (DeviceActionAttribute, DeviceActionVoter and the device action resource).
 * Every right is global; the API has no context permission for device actions.
 *
 * - POST /device_actions and POST /bulk_device_actions: create_any
 * - PATCH /device_actions/{id}: read_any, or the action belongs to the current user (DeviceActionVoter::hasAccess)
 * - DELETE /device_actions/{id}: delete_any
 */
export class DeviceActionVoter extends ContextVoter {
  private hasGlobal(attribute: PermissionAttributesEnum): boolean {
    return this.permissionService.getGlobalPermissionForUser({ attribute }) !== null;
  }

  public canCreate(): boolean {
    return this.hasGlobal(PermissionAttributesEnum.GlobalOperationDeviceactionCreateany);
  }

  public canEdit(item: Pick<DeviceActionHydraCollectionItem, "relatedUser">): boolean {
    if (this.hasGlobal(PermissionAttributesEnum.GlobalOperationDeviceactionReadany)) {
      return true;
    }

    const userIri = this.permissionService.userIri;
    return !!userIri && item.relatedUser === userIri;
  }

  public canDelete(): boolean {
    return this.hasGlobal(PermissionAttributesEnum.GlobalOperationDeviceactionDeleteany);
  }
}
